import { Chip } from "@mui/material";
import { ChipList } from "./chip-list";

function AppChip(props) {
  return <Chip {...props} />;
}

export { ChipList, AppChip };
